import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledSearchAndFilter = styled.div`
  .filter-open-btn {
    display: flex;
    height: auto;
    padding: 11px 14px !important;
    border-radius: 5px;
    font-family: ${(props) => props.theme.fontText};
    font-weight: 500;
  }

  .filter-open-btn:hover {
    background: ${({ theme }) => theme.bgColorHover} !important;
    border-color: ${({ theme }) => theme.colorBorder} !important;
    color: ${({ theme }) => theme.white} !important;
  }

  .search-section {
    width: 100%;
    padding-top: 9px;
    padding-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding-right: 10px;
    background-color: ${({ theme }) => theme.brightGrey};

    &.search-section-no-search {
      justify-content: flex-start;
      padding-left: 20px;
    }

    .ant-input-affix-wrapper {
      border: 1px solid ${({ theme }) => theme.bgColorHover};

      .ant-input-prefix {
        display: inline-block;
        margin-right: 15px;
      }

      .ant-input {
        font-weight: 500;
        font-size: 16px;

        &::placeholder {
          color: ${({ theme }) => theme.black};
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .search-section {
      padding: 10px 20px;
      .ant-form {
        .ant-input {
          font-size: 1rem;
        }
      }
    }

    .search-section-fixed {
      position: fixed !important;
      top: 0px !important;
      z-index: 1200;
    }
  }

  @media only screen and (max-height: 870px) {
    .mobile-search-section-box {
      margin-right: 10px;
    }

    .mobile-serach-fixed {
      display: none !important;
    }
  }

  @media only screen and (max-height: 870px) {
    .mobile-search-section-box {
      margin-right: 10px;
    }

    &.mobile-search-fixed .search-section {
      position: fixed !important;
      top: 238px;
      z-index: 1;
    }
  }

  @media only screen and (max-height: 750px) {
    &.mobile-search-fixed .search-section {
      top: 170px;
    }
  }
`;
